<template>
  <div>
    <base-wrapper :loading="loading">
      <div class="space-y-4">
        <shipment-card label="Cashbill" :stock-movement="stockMovement" />

        <base-card
          title="Informasi Kemasan"
          description="Daftar kemasan yang akan dikirim ke Stockist"
        >
          <div class="grid grid-cols-3 gap-6 border-t pt-5">
            <base-input
              class="col-span-full"
              inset
              disabled
              label="Nama Kemasan"
              :value="stockMovement.data.attributes.code"
            />

            <datatable class="col-span-full" :columns="productColumns">
              <template #tbody="{ classes }">
                <tr
                  v-for="product in getIncludedByType(stockMovement, 'movement-details')"
                  :key="product.id"
                  :class="classes.tr"
                >
                  <td :class="classes.td">
                    <p class="font-bold text-gray-900">
                      {{ product.attributes.product_code }}
                    </p>
                  </td>
                  <td :class="classes.td">{{ product.attributes.product_name }}</td>
                  <td :class="[classes.td, 'text-right']">
                      {{ product.attributes.shipped_product_qty | toCurrency }}
                  </td>
                </tr>
              </template>
            </datatable>
          </div>
        </base-card>

        <ShipmentReceiptCard
          v-if="stockMovement.data.attributes.is_shipped"
          :order="order"
          v-model="stockMovement"
        />

        <div class="flex justify-between">
          <div>
            <base-button
              v-if="!stockMovement.data.attributes.is_shipped"
              color="white"
              @click="cancelConfirmationVisible = true"
            >
              <Icon icon="heroicons:x-mark-solid" class="h-4 w-4" />
              Batalkan Faktur Kemasan
            </base-button>
            <base-button
              v-else
              color="white"
              @click="cancelConfirmationVisible = true"
            >
              <Icon icon="heroicons:x-mark-solid" class="h-4 w-4" />
              Batalkan Pengiriman
            </base-button>
          </div>
          <div class="flex gap-2">
            <base-button
              v-if="!stockMovement.data.attributes.is_shipped"
              @click="sendModalVisible = true"
            >
              <Icon icon="heroicons:truck-solid" class="h-4 w-4" />
              {{ stockMovement.data.attributes.shipment_type === 'pickup' ? 'Ambil' : 'Kirim' }}
            </base-button>
            <base-button color="white" :to="indexPath">
              <Icon icon="heroicons:arrow-uturn-left-solid" class="h-4 w-4" />
              Kembali
            </base-button>
          </div>
        </div>
      </div>

      <view-packet-modal
        :with-complain-form="false"
        :packet="detailKoliModal.packet"
        :visible="detailKoliModal.visible"
        with-batches
        @close="detailKoliModal.visible = false"
      />
      <cancel-shipment-confirmation
        :visible="cancelConfirmationVisible"
        :stock-movement-id="stockMovement.data.id"
        :type="stockMovement.data.attributes.is_shipped ? 'shipment' : 'packing'"
        @close="cancelConfirmationVisible = false"
        @confirmed="$router.push(indexPath)"
      />
      <send-stock-movement-modal
        :visible="sendModalVisible"
        :stock-movement="stockMovement"
        @close="sendModalVisible = false"
        @sent="$router.push(indexPath)"
      />
    </base-wrapper>
  </div>
</template>

<script>
import ViewPacketModal from '@/components/stock-movement/view-packet-modal.vue';
import CancelShipmentConfirmation from '@/components/stock-movement/cancel-shipment-confirmation.vue';
import { requestMixin } from '@/mixins/request/request';
import SendStockMovementModal from '@/components/stock-movement/send-stock-movement-modal.vue';
import ShipmentCard from '@/components/shipment/shipment-card.vue';
import ShipmentReceiptCard from '../../../../../components/shipment/shipment-receipt-card.vue';

export default {
  components: {
    ViewPacketModal,
    CancelShipmentConfirmation,
    SendStockMovementModal,
    ShipmentCard,
    ShipmentReceiptCard
  },
  mixins: [requestMixin],
  data() {
    return {
      indexPath: { name: 'gudang.pengiriman.barang-ke-mitra' },
      detailKoliModal: {
        visible: false,
        packet: {},
      },
      cancelConfirmationVisible: false,
      sendModalVisible: false,
      loading: false,
      stockMovement: {
        data: {
          attributes: {},
          relationships: {
            order: {
              data: {},
            },
            'destination-office': {
              data: {},
            },
          },
        },
        included: [],
      },
    };
  },
  computed: {
    order() {
      return this.getSingleIncluded(
        this.stockMovement,
        this.stockMovement.data.relationships.order.data.id
      );
    },
    productColumns() {
      return [
        {
          id: 'kode barang',
          name: 'Kode Barang',
        },
        {
          id: 'nama barang',
          name: 'Nama Barang',
        },
        {
          id: 'jumlah',
          name: 'Jumlah',
          theadClass: 'text-right',
        }
      ];
    },
  },
  methods: {
    async loadStockMovement() {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/stock-movements/${this.$route.params.id}`,
        {
          params: {
            include: 'order,destination-office,movement-details',
            'fields[stock-movements]':
              'code,updatedAt,is_shipped,airwaybill_number,taken_by,order,destination-office,shipment_type,movement-details',
            'fields[orders]': 'complete_shipment_address,origin_code,destination_code,order_shipment,grand_total_price,shipping_fee,plastic_qty,is_transfer_promo,is_transfer_promo_regular',
            'fields[offices]': 'code,name,address,full_address,phone',
          },
        }
      );

      if (!err) {
        this.stockMovement = res;
      }

      this.loading = false;
    },
    onClickDetailKoli(packet) {
      this.detailKoliModal.packet = packet;
      this.detailKoliModal.visible = true;
    },
  },
  created() {
    this.loadStockMovement();
  },
};
</script>
